// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ActionableFiltersForm, SummaryFiltersForm, OnlineContentFiltersForm, SearchFiltersForm } from "../schema";
import { serialize_ActionableFiltersForm_internal, deserialize_ActionableFiltersForm_internal } from "./ActionableFiltersForm";
import { serialize_SummaryFiltersForm_internal, deserialize_SummaryFiltersForm_internal } from "./SummaryFiltersForm";
import { serialize_OnlineContentFiltersForm_internal, deserialize_OnlineContentFiltersForm_internal } from "./OnlineContentFiltersForm";

export function serialize_SearchFiltersForm_internal(value: SearchFiltersForm): unknown {
  return ((value: {
    actionableLanguageFormFilter: ActionableFiltersForm;
    channelPage: number;
    query: string;
    summariesPage: number;
    summarySearchFilters: SummaryFiltersForm;
    verifaiFiltersForm: OnlineContentFiltersForm;
    verifaiPage: number;
  }): unknown => {
    return {
      actionableLanguageFormFilter: ((value: ActionableFiltersForm): unknown => {
        return serialize_ActionableFiltersForm_internal(value);
      })(value["actionableLanguageFormFilter"]),
      channelPage: ((value: number): unknown => {
        return value;
      })(value["channelPage"]),
      query: ((value: string): unknown => {
        return value;
      })(value["query"]),
      summariesPage: ((value: number): unknown => {
        return value;
      })(value["summariesPage"]),
      summarySearchFilters: ((value: SummaryFiltersForm): unknown => {
        return serialize_SummaryFiltersForm_internal(value);
      })(value["summarySearchFilters"]),
      verifaiFiltersForm: ((value: OnlineContentFiltersForm): unknown => {
        return serialize_OnlineContentFiltersForm_internal(value);
      })(value["verifaiFiltersForm"]),
      verifaiPage: ((value: number): unknown => {
        return value;
      })(value["verifaiPage"]),
    };
  })(value);
}
export function serialize_SearchFiltersForm(obj: SearchFiltersForm): string {
  return renderJsonWithNumbersAsBigint(serialize_SearchFiltersForm_internal(obj));
}
export function deserialize_SearchFiltersForm_internal(value: unknown): ParserResult<SearchFiltersForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    actionableLanguageFormFilter: ActionableFiltersForm;
    channelPage: number;
    query: string;
    summariesPage: number;
    summarySearchFilters: SummaryFiltersForm;
    verifaiFiltersForm: OnlineContentFiltersForm;
    verifaiPage: number;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "actionableLanguageFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/actionableLanguageFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionableLanguageFormFilter'.` };
    }
    const parsed_actionableLanguageFormFilter = ((): ParserResult<ActionableFiltersForm> => {
      return ((value: unknown): ParserResult<ActionableFiltersForm> => {
        return deserialize_ActionableFiltersForm_internal(value);
      })(value["actionableLanguageFormFilter"]);
    })();
    if (!parsed_actionableLanguageFormFilter.success) {
      return { success: false, reason: parsed_actionableLanguageFormFilter.reason };
    }
    if (!hasProp(value, "channelPage")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/channelPage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'channelPage'.` };
    }
    const parsed_channelPage = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SearchFiltersForm/channelPage]: '${value}' expected to be of type number.` };
      })(value["channelPage"]);
    })();
    if (!parsed_channelPage.success) {
      return { success: false, reason: parsed_channelPage.reason };
    }
    if (!hasProp(value, "query")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/query]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'query'.` };
    }
    const parsed_query = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SearchFiltersForm/query]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["query"]);
    })();
    if (!parsed_query.success) {
      return { success: false, reason: parsed_query.reason };
    }
    if (!hasProp(value, "summariesPage")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/summariesPage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summariesPage'.` };
    }
    const parsed_summariesPage = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SearchFiltersForm/summariesPage]: '${value}' expected to be of type number.` };
      })(value["summariesPage"]);
    })();
    if (!parsed_summariesPage.success) {
      return { success: false, reason: parsed_summariesPage.reason };
    }
    if (!hasProp(value, "summarySearchFilters")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/summarySearchFilters]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summarySearchFilters'.` };
    }
    const parsed_summarySearchFilters = ((): ParserResult<SummaryFiltersForm> => {
      return ((value: unknown): ParserResult<SummaryFiltersForm> => {
        return deserialize_SummaryFiltersForm_internal(value);
      })(value["summarySearchFilters"]);
    })();
    if (!parsed_summarySearchFilters.success) {
      return { success: false, reason: parsed_summarySearchFilters.reason };
    }
    if (!hasProp(value, "verifaiFiltersForm")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/verifaiFiltersForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifaiFiltersForm'.` };
    }
    const parsed_verifaiFiltersForm = ((): ParserResult<OnlineContentFiltersForm> => {
      return ((value: unknown): ParserResult<OnlineContentFiltersForm> => {
        return deserialize_OnlineContentFiltersForm_internal(value);
      })(value["verifaiFiltersForm"]);
    })();
    if (!parsed_verifaiFiltersForm.success) {
      return { success: false, reason: parsed_verifaiFiltersForm.reason };
    }
    if (!hasProp(value, "verifaiPage")) {
      return { success: false, reason: `[#/components/schemas/SearchFiltersForm/verifaiPage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifaiPage'.` };
    }
    const parsed_verifaiPage = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SearchFiltersForm/verifaiPage]: '${value}' expected to be of type number.` };
      })(value["verifaiPage"]);
    })();
    if (!parsed_verifaiPage.success) {
      return { success: false, reason: parsed_verifaiPage.reason };
    }
    return {
      success: true,
      value: {
        actionableLanguageFormFilter: parsed_actionableLanguageFormFilter.value,
        channelPage: parsed_channelPage.value,
        query: parsed_query.value,
        summariesPage: parsed_summariesPage.value,
        summarySearchFilters: parsed_summarySearchFilters.value,
        verifaiFiltersForm: parsed_verifaiFiltersForm.value,
        verifaiPage: parsed_verifaiPage.value,
      },
    };
  })(value);
}
export function deserialize_SearchFiltersForm(str: string): ParserResult<SearchFiltersForm> {
  return deserialize_SearchFiltersForm_internal(parseJsonWithNumbersAsBigint(str));
}
